import { Link } from 'react-router-dom'
import { useSite } from '../context/SiteContext.jsx'
import { usePeptides } from '../context/PeptidesContext.jsx'
import { useGlossary } from '../context/GlossaryContext.jsx'
import SystemStatus from '../components/SystemStatus.jsx'
import { ALL_ARTICLES } from '../lib/articles.js'

export default function AdminHub() {
  const { configured } = useSite()
  const { peptides, source } = usePeptides()
  const { glossary } = useGlossary()

  const liveArticles = ALL_ARTICLES.filter((a) => a.status === 'live').length
  const scheduledArticles = ALL_ARTICLES.filter((a) => a.status === 'scheduled').length

  const cards = [
    { to: '/admin/peptides', icon: '🧬', title: 'Peptide Library', desc: 'Add, edit, and organize peptide & amino profiles.', meta: `${peptides.length} entries` },
    { to: '/admin/articles', icon: '📝', title: 'Articles', desc: 'See the blog pipeline — live posts and scheduled drafts with their publish dates.', meta: `${liveArticles} live · ${scheduledArticles} scheduled` },
    { to: '/admin/glossary', icon: '📖', title: 'Glossary', desc: 'Add and edit glossary term definitions — each gets its own SEO page.', meta: `${glossary.length} terms` },
    { to: '/admin/stats', icon: '📊', title: 'Signup Stats', desc: 'Signups per week vs last week, sources, and mobile vs desktop — from your own DB.', meta: 'Analytics' },
    { to: '/admin/utm', icon: '🔗', title: 'UTM Link Builder', desc: 'Generate correctly-tagged links for TikTok, IG, email so GA4 attributes them right.', meta: 'Analytics' },
    { to: '/admin/banners', icon: '🖼️', title: 'Calculator Banners', desc: 'Manage the rotating ad/image strip, with per-banner UTM tags.', meta: 'Ads & images' },
    { to: '/admin/emails', icon: '✉️', title: 'Email Templates', desc: 'Edit the welcome and dose-reminder emails — subject, HTML, live preview.', meta: 'Welcome & reminders' },
    { to: '/admin/emails-log', icon: '📬', title: 'Email Log', desc: 'See welcome + dose-reminder emails your crons have actually sent, with counts.', meta: 'Sent history' },
    { to: '/admin/integrations', icon: '🔌', title: 'Integrations', desc: 'Send new signups to a webhook (GoHighLevel, etc.) — email, name, opt-in and more.', meta: 'Webhooks' },
  ]

  return (
    <main className="page">
      <div className="container">
        <span className="pill blue" style={{ marginBottom: 8 }}>Admin</span>
        <h1 className="section-title">Site Admin</h1>
        <p className="section-sub">One place to manage everything editable on the site. Changes save to your database and go live immediately.</p>

        {!configured && (
          <div className="config-notice" style={{ marginBottom: 18 }}>
            <strong>Backend not connected.</strong>
            <p>Editing needs Supabase. Add your keys and run the SQL in <code>supabase/</code>, then reload.</p>
          </div>
        )}
        {configured && source === 'empty' && (
          <div className="config-notice" style={{ marginBottom: 18 }}>
            <strong>Peptide table is empty.</strong>
            <p>Open <em>Peptide Library</em> and click “Import starter library” to populate it.</p>
          </div>
        )}

        <div style={{ margin: '0 0 20px', maxWidth: 520 }}>
          <SystemStatus />
        </div>

        <div className="admin-hub-grid">
          {cards.map((c) => (
            <Link key={c.to} to={c.to} className="card admin-hub-card">
              <div className="admin-hub-icon">{c.icon}</div>
              <h3>{c.title}</h3>
              <p>{c.desc}</p>
              <span className="admin-hub-meta">{c.meta} →</span>
            </Link>
          ))}
        </div>
      </div>
    </main>
  )
}
